require('easy-autocomplete/dist/jquery.easy-autocomplete.min.js');
require('easy-autocomplete/dist/easy-autocomplete.min.css');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');

var RemoteSuggesterView = Marionette.View.extend({
    template: require('../../templates/common/remote-suggester-input.html'),
    events: {},

    templateContext: function () {
        var that = this;
        return {
            classes: that.classes,
            inputId: that.inputId
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'getSelectedId', 'getSelectedValue', 'listLocationWrapper');
        var that = this;
        that.utils = new CommonUtils();

        that.multiSelect = options.multiSelect ? true : false;
        that.requestDelay = options.requestDelay || 1000;
        that.inputId = options.inputId || that.utils.generatedUUID();
        that.url = options.url;
        that.symbolForSearchInUrl = options.symbolForSearchInUrl;
        that.listLocation = options.listLocation;
        that.getValueFn = options.getValueFn;
        that.getIdFn = options.getIdFn;
        that.ajaxMethod = options.method || 'GET';
        that.ajaxDataType = options.ajaxDataType || 'json';
        that.classes = options.classes || [];
        that.placeholder = options.placeholder;
        that.maxNumberOfElements = options.maxNumberOfElements || 20;
        that.tag = options.tag;

        that.findSelectedIdBySelectedValue = options.findSelectedIdBySelectedValue;
        that.findSelectedIdBySelectedIndex = options.findSelectedIdBySelectedIndex;
        that.defaultSelected = options.defaultSelected;
        that.selectedIndex = null;
        that.selectedIds = [];
        that.anySymbol = new RegExp("^[A-Za-z0-9? ,_-]+$");

        //internallyUsed
        that.previousOptions = [];
    },

    onRender: function () {
        var that = this;

        if (that.multiSelect) {

            var defaultItems;
            if (that.defaultSelected != undefined) {
                defaultItems = (that.defaultSelected || []).map(function (item) {
                    return {
                        id: that.getIdFn(item),
                        name: that.getValueFn(item)
                    }
                });
                that.selectedIds = (defaultItems || []).map(function (item) {
                    return item.id;
                });
            }

            //fix to restore a lose input val
            var inputRestore = function (selectize_, searchText_, time) {
                window.setTimeout(function () {
                    selectize_.$control_input.val(searchText_);
                    var size = 10 * searchText_.length;
                    selectize_.$control_input.css('width', size + 50);
                }, time);
            };

            $(function () {
                $('#' + that.inputId).removeClass('form-control');
                var select = $('#' + that.inputId).selectize({
                    plugins: ['remove_button'],
                    inputClass: 'form-control selectize-input normal-width selectized',
                    valueField: 'id',
                    labelField: 'name',
                    placeholder: that.placeholder,
                    sortField: 'name',
                    options: defaultItems || [],
                    items: (defaultItems || []).map(function (item) {
                        return item.id;
                    }),
                    highlight: true,
                    openOnFocus: true
                });

                var selectize = select[0].selectize;
                var lazyRequest;
                var inputVal = '';

                selectize.$control_input.on('keyup', function (event) {

                    if (lazyRequest)
                        clearTimeout(lazyRequest);

                    var searchText = event.target.value;
                    inputVal = searchText;

                    if (searchText == '') {
                        inputRestore(selectize, searchText, 0);
                        if (!_.isEmpty(that.previousOptions)) {
                            if (_.isEmpty(that.selectedIds))
                                selectize.clearOptions();
                            else {
                                that.previousOptions.forEach(function (option) {
                                    if (that.selectedIds.filter(function (id) {
                                            return id == option.id;
                                        }).length == 0) {
                                        selectize.removeOption(option.id);
                                    }
                                });
                            }
                        }
                        window.setTimeout(function () {
                            selectize.$control_input.parent().removeClass('data-loader');
                        }, 1000);
                        selectize.close();
                        return;
                    }

                    var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);

                    if (that.anySymbol.test(str) || event.target.value != '' && (event.keyCode == 8 || event.keyCode == 46)) {
                        selectize.$control_input.parent().addClass('data-loader');
                    } else {
                        return;
                    }

                    lazyRequest = setTimeout(function () {

                        $.when(
                            $.ajax({
                                type: "GET",
                                url: that.url.replace(that.symbolForSearchInUrl, searchText),
                            })
                        ).done(function (resp) {
                            if (!_.isEmpty(that.previousOptions)) {
                                if (_.isEmpty(that.selectedIds))
                                    selectize.clearOptions();
                                else {
                                    that.previousOptions.forEach(function (option) {
                                        if (that.selectedIds.filter(function (id) {
                                                return id == option.id;
                                            }).length == 0) {
                                            selectize.removeOption(option.id);
                                        }
                                    });
                                }
                            }

                            var list = that.listLocationWrapper(resp);
                            var formattedResult = list.map(function (elem) {
                                return {
                                    id: that.getIdFn(elem),
                                    name: that.getValueFn(elem)
                                }
                            });
                            that.previousOptions = formattedResult;

                            for (var ind in formattedResult) {
                                if (ind >= that.maxNumberOfElements)
                                    break;
                                selectize.addOption(formattedResult[ind]);
                            }

                            selectize.$control_input.on('blur', function () {
                                selectize.onBlur.apply(selectize, arguments);
                                inputRestore(selectize, inputVal, 0);
                            });
                            selectize.$control_input.on('focus', function () {
                                selectize.onBlur();
                                selectize.open();
                                inputRestore(selectize, inputVal, 0);
                            });

                            selectize.onBlur();
                            selectize.open();
                            inputRestore(selectize, searchText, 0);

                            selectize.$control_input.parent().removeClass('data-loader');

                        }).fail(function (jqXHR, textStatus) {
                            selectize.$control_input.parent().removeClass('data-loader');
                            console.log(jqXHR);
                        });
                    }, that.requestDelay);

                });

                selectize.on('item_add', function (value, item) {
                    inputRestore(selectize, inputVal, 0);
                    that.selectedIds.push(value);
                    that.triggerMethod("suggestor:multi:add:id:" + that.tag, value);
                });

                selectize.on('item_remove', function (value, item) {
                    inputRestore(selectize, inputVal, 0);
                    that.selectedIds = that.selectedIds.filter(function (item) {
                        return item != value;
                    });
                    that.triggerMethod("suggestor:multi:remove:id:" + that.tag, value);
                });
            });

        } else {
            var options = {
                placeholder: that.placeholder,
                requestDelay: that.requestDelay,
                url: function (phrase) {
                    return that.url.replace(that.symbolForSearchInUrl, phrase);
                },

                listLocation: that.listLocationWrapper,
                getValue: that.getValueFn,
                ajaxSettings: {
                    dataType: that.ajaxDataType,
                    method: that.ajaxMethod,
                    data: {
                        dataType: that.ajaxDataType
                    }
                },
                list: {
                    maxNumberOfElements: that.maxNumberOfElements,
                    onLoadEvent: function () {
                        $('#' + that.inputId).removeClass('data-loader');
                        that.selectedIndex = null;
                        that.sendSelectedIdToParent();
                    },
                    onChooseEvent: function () {
                        var selectedLi = $("div#eac-container-" + that.inputId + " > ul > li.selected");
                        that.selectedIndex = $("div#eac-container-" + that.inputId + " > ul > li").index(selectedLi);
                        $('#' + that.inputId).removeClass('data-loader');
                        that.sendSelectedIdToParent();
                    }
                },
                preparePostData: that.ajaxMethod == 'POST' ? function (data) {
                    data.phrase = $('#' + that.inputId).val();
                    return data;
                } : null
            };

            $(function () {
                $('#' + that.inputId).easyAutocomplete(options);
                $('.easy-autocomplete').removeAttr('style');

                if (that.defaultSelected != undefined) {
                    that.resultArr = [that.defaultSelected];
                    that.selectedIndex = 0;
                    $('#' + that.inputId).val(that.getValueFn(that.defaultSelected));
                }

                $('#eac-container-' + that.inputId).css({'max-height': 200, 'overflow-y': 'auto'});

                $('#' + that.inputId).keyup(function (e) {
                    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);

                    if (that.anySymbol.test(str) || e.target.value != '' && (e.keyCode == 8 || e.keyCode == 46))
                        $('#' + that.inputId).addClass('data-loader');

                    // for fix a unknown bug in mozilla.
                    $('#' + that.inputId).show();

                    if (e.target.value == '') {
                        that.selectedIndex = null;
                        that.sendSelectedIdToParent();
                    }

                    window.setTimeout(function () {
                        // remove loader when ajax error because easyAutocomplete can not
                        $('#' + that.inputId).removeClass('data-loader');
                    }, that.requestDelay + 5000)
                });
            });
        }
    },

    sendSelectedIdToParent: function () {
        if (this.tag) {
            this.triggerMethod("suggestor:selected:" + this.tag, this.findSelectedIdBySelectedIndex(this.resultArr, this.selectedIndex));
        }
    },

    getSelectedSingleObject: function (id) {
        return _.findWhere(this.resultArr, {id: id});
    },

    getSelectedId: function () {
        if (this.multiSelect)
            return;

        var that = this;
        if (typeof that.findSelectedIdBySelectedValue != "undefined") {
            return that.findSelectedIdBySelectedValue(that.resultArr, that.getSelectedValue());
        } else if (typeof that.findSelectedIdBySelectedIndex != "undefined" && that.selectedIndex != null) {
            return that.findSelectedIdBySelectedIndex(that.resultArr, that.selectedIndex);
        }
        else return null;
    },

    getSelectedIdsList: function () {
        if (!this.multiSelect)
            return [];
        return this.selectedIds;
    },

    getSelectedValue: function () {
        if (this.multiSelect)
            return;

        return $('#' + this.inputId).val();
    },

    listLocationWrapper: function (data) {
        var list = this.listLocation(data);
        this.resultArr = list;
        return list;
    },

});

module.exports = RemoteSuggesterView;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/remote-suggester-input.js
// module id = 196
// module chunks = 0